import React from "react";
import { Link } from "react-router-dom";
import { Handshake } from "lucide-react";
import { COLORS, SERIF, HEADER } from "./dispute/theme";

const wordmarkStyle = { fontFamily: SERIF, fontSize: HEADER.logoSize, fontWeight: 600, letterSpacing: "-0.3px" };
const brandStyle = { display: "inline-flex", alignItems: "center", gap: 8, color: COLORS.ink };

// The single source of truth for the "disputefAI" brand mark used in every
// sticky header across the app. Pass `to` for a client-side route link, or
// `onClick` for a plain click handler (e.g. the admin console, which isn't
// always inside a place where /home is the obvious destination).
export default function Logo({ to, onClick, style, iconColor, iconSize }) {
  const content = (
    <span style={{ ...brandStyle, ...style }}>
      <Handshake size={iconSize || HEADER.logoSize} strokeWidth={1.75} style={{ color: iconColor || "currentColor", flexShrink: 0 }} />
      <span style={wordmarkStyle}>
        disputef<em style={{ fontStyle: "italic" }}>AI</em>
      </span>
    </span>
  );

  if (onClick) {
    return (
      <span onClick={onClick} style={{ cursor: "pointer", textDecoration: "none" }}>
        {content}
      </span>
    );
  }
  return (
    <Link to={to || "/home"} style={{ textDecoration: "none" }}>
      {content}
    </Link>
  );
}
